module.exports = __webpack_public_path__ + "img/live.71d42eee.gif";